import './App.css';
import { useLocation } from "react-router-dom";
import AppRoutes from './routes/AppRoutes';
import 'remixicon/fonts/remixicon.css';

function App() {
  return (
    <>
      <AppRoutes />
    </>
  );
}

export default App;
